import React from "react";
import { Badge, BadgeProps } from "@mantine/core";

type RefundStatus = "none" | "partial" | "full" | null | undefined;

const LABELS: Record<"partial" | "full", string> = {
  partial: "Partially refunded",
  full: "Refunded",
};

interface RefundStatusBadgeProps extends Omit<BadgeProps, "children"> {
  /** The transaction-level refund axis (transactions.refund_status). */
  refundStatus: RefundStatus;
}

/**
 * Renders a "Partially refunded" / "Refunded" badge from the transaction-level
 * `refund_status` axis, or nothing when there is no refund (`none`/undefined).
 *
 * Kept as its own axis so it can sit alongside the appointment-status badge
 * (e.g. "Completed · Refunded") without overloading appointment/transaction
 * status. Driven by the lightweight scalar, so it survives a page refresh.
 */
export default function RefundStatusBadge({
  refundStatus,
  ...badgeProps
}: RefundStatusBadgeProps) {
  if (refundStatus !== "partial" && refundStatus !== "full") return null;
  return (
    <Badge color="orange" variant="light" {...badgeProps}>
      {LABELS[refundStatus]}
    </Badge>
  );
}
